import animateScrollTo from "animated-scroll-to";

export function initScroll() {
	scroll();

	$.nette.ext("reinitScroll", {
		success: function () {
			scroll();
		}
	});
}

function scroll() {
	$(".scroll").on("click", function (e) {
		e.preventDefault();

		animateScrollTo(document.querySelector($(this).attr("href")), {
			offset: window.innerWidth <= 992 ? 0 : -88,
			cancelOnUserAction: false,
		});

		if ($(this).hasClass("nav-link") && window.innerWidth <= 992) {
			$(".navbar-toggler").click();
		}
	});
}
